
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/DYNAMIC_PAGES/guided-motorcycle-tours/_slug/reviews",
      function () {
        return require("private-next-pages/DYNAMIC_PAGES/guided-motorcycle-tours/_slug/reviews.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/DYNAMIC_PAGES/guided-motorcycle-tours/_slug/reviews"])
      });
    }
  